import { Button, Form } from "react-bootstrap"

export default function DateInputForm(props){
    // date input form for date ranges and/or comparisons between 2 dates
    // props: 
    //    comparison: true -> change headings to first date, second date
    //                false -> headings start date, end date
 
    return (
      <div className="mb-5">
        <div style={{display: "flex", justifyContent: "space-between"}}>
        <Form.Group
          controlId="date1"
          // className="me-3"
          style={{
            display: "inline-block",
            width: "45%",
            maxWidth: "270px",
          }}
        >
          <Form.Label>{props.comparison?"First Date"  : "Start Date"}</Form.Label>
          <Form.Control type="date" name="date1" value={props?.date1} onChange={(event) => props.setDate1(event.target.value)} max={props.date2}/>
        </Form.Group>
        <Form.Group
          controlId="date1"
          style={{
            display: "inline-block",
            width: "45%",
            maxWidth: "270px",
          }}
        >
          <Form.Label>{props.comparison?"Second Date"  : "End Date"}</Form.Label>
          <Form.Control type="date" name="date1" value={props?.date2} onChange={(event) => props.setDate2(event.target.value)} min={props.date1}/>
        </Form.Group>
        <Button style={{ height: "fit-content", alignSelf: "end"}} onClick={props.handleDateRangeClick}>
            Go
          </Button>
      </div>
      <p style={{color: "red", fontSize: "smaller", marginTop: "5px"}}>{props.inputError}</p>
      </div>
    )
        }